import { createBrowserRouter, Navigate } from 'react-router';

import Landing from '~/pages/Landing';
import Logout from '~/pages/Logout';
import GoogleCallback from '~/pages/login/GoogleAuth';
import MicrosoftCallback from '~/pages/login/MicrosoftAuth';
import ShopifyCallback from '~/pages/ShopifyCallback';
import MetaAdsCallback from '~/pages/MetaAdsCallback';
import ProtectedRoute from '~/components/ProtectedRoute';
import { RouteTracker } from '~/components/RouteTracker';
import AppLayout from '~/layouts/AppLayout';
import Dashboard from '~/components/app/pages/Dashboard';
import BlogIndex from '~/pages/blog/index';
import BlogArticle from '~/pages/blog/BlogArticle';
import ShopifySetupGuide from '~/pages/docs/ShopifySetupGuide';

export const router = createBrowserRouter([
  {
    element: <RouteTracker />,
    children: [
      // Public routes
      {
        path: '/',
        element: <Landing />
      },
      {
        path: '/logout',
        element: <Logout />
      },
      {
        path: '/login/authenticate/google',
        element: <GoogleCallback />
      },
      {
        path: '/login/authenticate/microsoft',
        element: <MicrosoftCallback />
      },
      // Shopify callback - standalone route (not inside AppLayout to avoid scope check loop)
      {
        path: '/app/shopify/callback',
        element: (
          <ProtectedRoute>
            <ShopifyCallback />
          </ProtectedRoute>
        )
      },

      // Blog routes (public)
      {
        path: '/blog',
        element: <BlogIndex />
      },
      {
        path: '/blog/:slug',
        element: <BlogArticle />
      },

      // Docs routes (public)
      {
        path: '/docs/shopify-setup-guide',
        element: <ShopifySetupGuide />
      },

      // Protected routes (wrapped in ProtectedRoute + AppLayout)
      {
        path: '/app',
        element: (
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        ),
        children: [
          { index: true, element: <Navigate to="dashboard" replace /> },
          { path: 'dashboard', element: <Dashboard /> },
          // Meta callback stays inside AppLayout (no scope check issues like Shopify)
          { path: 'meta-ads/callback', element: <MetaAdsCallback /> },
        ]
      }
    ]
  }
]);
